import { SelectWithLabel } from 'components/Form'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { Collapse } from 'reactstrap'
import { getStaticImage } from 'utils/statics'
import { statePaymentsOptions } from './constants/statesPayments'
import RenderItemAction from './RenderItemAction'
import './styles.scss'

const PluginPayment = ({ plugins, user }) => {
  const [open, setOpen] = useState(false)
  const [filter, setFilter] = useState(false)
  const [filterSelected, setFilterSelected] = useState('show_all')
  const [actionSelected, setActionSelected] = useState('payments') //default
  const [stateInfo, setStateInfo] = useState('')
  const [idOrderSelected, setIdOrderSelected] = useState('')

  const paymentOptions = statePaymentsOptions.map(op => ({ value: op.value, label: I18n.t(op.label) }))

  const onToggle = (isRemoveByUser) => {
    setOpen((state) => (isRemoveByUser ? false : !state))
  }

  useEffect(() => {
    if(!open) {
      setActionSelected('payments')
      setFilterSelected('show_all')
    }
  }, [open, user])

  useEffect(() => {
    if(actionSelected !== 'payments') setActionSelected('payments')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user._id])


  useEffect(() => {
    if(actionSelected !== 'payments' && filter) setFilter(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionSelected])

  const handleChangeFilter = (item)=>{
    if(item){
      setFilterSelected(item.value)
    } else{
      setFilterSelected('show_all')
    }
  }

  return (
    <div
      className={`plugin-payment-card ${user.isRemoveByUser ? 'disabled' : ''
        }`}>
      <div className={'title-container'}>
        <div className={'title'}>
          <figure>
            <img
              src={getStaticImage('/icons/orange-brand/icon-money-dark.svg')}
              alt="Payment"
            />
          </figure>
          <p>{I18n.t('dashboard_payment-gateway')}</p>
        </div>
        <div className={'action-buttons-container'}>
          {actionSelected !== 'newPayment' &&
          <>
            {actionSelected === 'payments'&&
              <i className={`fa fa-filter $`} onClick={() =>{
                setOpen(true)
                setFilter(!filter)
                setFilterSelected('show_all')
              }} />
            }
            <i
              className={`fa fa-plus-circle`}
              onClick={() => {
                setFilter(false)
                setFilterSelected('show_all')
                setOpen(true)
                setActionSelected('newPayment')
                setStateInfo('created')
              }}
            />
          </>
          }
          <i
            className={`fa fa-chevron-${open ? 'up' : 'down'}`}
            onClick={() => onToggle(user.isRemoveByUser)}
          />
        </div>
      </div>
      <div className={`content-container`}>
        <Collapse isOpen={open} >
          <div className='separator' />
          {actionSelected !== 'payments' &&
            <div className={'container-header-payment'}>
              <div className='title-and-back'>
                <i
                  className={`fa fa-chevron-left`}
                  onClick={() => {
                    setActionSelected('payments')
                    setStateInfo('')
                  }}
                />
                <p>{I18n.t(`dasboard_payment_${actionSelected}`)}</p>
              </div>
              <img
                src={getStaticImage(`/icons/orange-brand/icon-payment-${stateInfo}.svg`)}
                alt=""
                className="icon-payment-info"
              />
            </div>
          }
          <Collapse isOpen={filter} >
            <div className='container-filter'>
              <SelectWithLabel
                name='states'
                key='states'
                placeholder={I18n.t('dashboard_payment_status')}
                options={paymentOptions}
                value={paymentOptions.find(element => element.value === filterSelected)}
                onChange={handleChangeFilter}
                classNameWrapper={'state-payments'}
                isClearable
              />
            </div>
          </Collapse>
          {open &&
            <RenderItemAction actionSelected={actionSelected} idOrderSelected={idOrderSelected} plugins={plugins} setActionSelected={setActionSelected} setIdOrderSelected={setIdOrderSelected} user={user} setStateInfo={setStateInfo} filterSelected={filterSelected} />
          }
        </Collapse>
      </div>
    </div>
  )
}

export default PluginPayment
